(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('community-gallery')) {
    class CommunityGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.items = Array.from(
          this.querySelectorAll('[data-gallery-item]')
        );
        this.dialog = this.querySelector('.community-gallery__dialog');
        this.lightboxImage = this.querySelector(
          '.community-gallery__lightbox-image'
        );
        this.meta = this.querySelector('[data-gallery-meta]');
        this.caption = this.querySelector('[data-gallery-caption]');
        this.byline = this.querySelector('[data-gallery-byline]');
        this.closeButton = this.querySelector('[data-gallery-close]');
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.stage = this.querySelector('[data-gallery-stage]');
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.opener = null;

        if (!this.dialog || this.items.length === 0) return;

        this.items.forEach((item, index) => {
          item.addEventListener('click', () => this.open(index, item));
        });

        this.closeButton.addEventListener(
          'click',
          () => this.dialog.close()
        );

        this.previousButton.addEventListener(
          'click',
          () => this.showPrevious()
        );

        this.nextButton.addEventListener(
          'click',
          () => this.showNext()
        );

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showPrevious();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showNext();
          }
        });

        this.dialog.addEventListener('close', () => {
          document.body.style.overflow =
            this.previousBodyOverflow || '';

          this.lightboxImage.removeAttribute('src');

          if (this.opener) this.opener.focus();
        });

        this.stage.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1) return;

            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        this.stage.addEventListener(
          'touchend',
          (event) => {
            if (event.changedTouches.length !== 1) return;

            const distanceX =
              event.changedTouches[0].clientX - this.touchStartX;

            const distanceY =
              event.changedTouches[0].clientY - this.touchStartY;

            if (
              Math.abs(distanceX) < 50 ||
              Math.abs(distanceX) <= Math.abs(distanceY)
            ) {
              return;
            }

            if (distanceX < 0) {
              this.showNext();
            } else {
              this.showPrevious();
            }
          },
          { passive: true }
        );

        const hideArrows = this.items.length <= 1;
        this.previousButton.hidden = hideArrows;
        this.nextButton.hidden = hideArrows;
      }

      open(index, opener) {
        this.currentIndex = index;
        this.opener = opener;
        this.update();
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.closeButton.focus();
      }

      showPrevious() {
        if (this.items.length <= 1) return;

        this.currentIndex =
          (this.currentIndex - 1 + this.items.length) %
          this.items.length;

        this.update();
      }

      showNext() {
        if (this.items.length <= 1) return;

        this.currentIndex =
          (this.currentIndex + 1) % this.items.length;

        this.update();
      }

      update() {
        const item = this.items[this.currentIndex];
        const caption = item.dataset.caption || '';
        const customerName = item.dataset.customerName || '';
        const location = item.dataset.location || '';
        const byline = [customerName, location]
          .filter(Boolean)
          .join(' · ');

        this.lightboxImage.removeAttribute('srcset');
        this.lightboxImage.removeAttribute('sizes');
        this.lightboxImage.src = item.dataset.fullImage;
        this.lightboxImage.alt = item.dataset.alt || '';
        this.lightboxImage.width =
          Number(item.dataset.imageWidth) || 1;
        this.lightboxImage.height =
          Number(item.dataset.imageHeight) || 1;

        this.caption.textContent = caption;
        this.byline.textContent = byline;
        this.caption.hidden = !caption;
        this.byline.hidden = !byline;
        this.meta.hidden = !caption && !byline;
      }
    }

    customElements.define(
      'community-gallery',
      CommunityGallery
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compact-customer-testimonials"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('compact-testimonials')) {
  customElements.define(
    'compact-testimonials',
    class CompactTestimonials extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ctc-track]');
        this.previousButton = this.querySelector('[data-ctc-previous]');
        this.nextButton = this.querySelector('[data-ctc-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));

        this.track.addEventListener(
          'scroll',
          () => this.updateButtons(),
          { passive: true }
        );

        this.resizeObserver = new ResizeObserver(
          () => this.updateButtons()
        );

        this.resizeObserver.observe(this.track);

        this.updateButtons();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        const card = this.track.querySelector('.ctc__card');
        if (!card) return;

        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;

        this.track.scrollBy({
          left: distance * direction,
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth'
        });
      }

      updateButtons() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;

        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled =
          this.track.scrollLeft >= maximum - 2;
      }
    }
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-faq')) {
    class ProductFaq extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.items = Array.from(
          this.querySelectorAll('[data-faq-item]')
        );

        this.items.forEach((item) => {
          const button = item.querySelector('[data-faq-button]');

          if (!button) return;

          button.addEventListener('click', () => {
            const shouldOpen =
              button.getAttribute('aria-expanded') !== 'true';

            this.closeAll();

            if (shouldOpen) this.open(item);
          });
        });
      }

      open(item) {
        const button = item.querySelector('[data-faq-button]');
        const panel = item.querySelector('[data-faq-panel]');

        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }

      closeAll() {
        this.items.forEach((item) => {
          const button = item.querySelector('[data-faq-button]');
          const panel = item.querySelector('[data-faq-panel]');

          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        });
      }
    }

    customElements.define('product-faq', ProductFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
